import { render } from "./LegalNotice.vue?vue&type=template&id=6a2a2cd4"
import script from "./LegalNotice.vue?vue&type=script&lang=js"
export * from "./LegalNotice.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__